import React, { useState } from 'react';

const FloatingContactButtons = () => {
  const phoneNumber = "919450785369";
  const [showAddress, setShowAddress] = useState(false);
  
  const address = "St. Xavier's Public School Bela, Cholapur Varanasi-221101";
  
  const openGoogleMaps = () => {
    const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
    window.open(url, "_blank");
  };
  
  const toggleAddress = () => {
    setShowAddress(!showAddress);
  };
  
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3 items-end">
      {/* WhatsApp Button */}
      <div className="flex items-center gap-2 group">
        <span className="bg-gray-800 text-white text-xs py-1 px-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
          WhatsApp
        </span>
        <a
          href={`https://wa.me/${phoneNumber}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-10 h-10 bg-green-500 rounded-full shadow-lg hover:bg-green-600 hover:scale-110 hover:shadow-xl transition-all duration-200"
        >
          <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2C6.48 2 2 6.48 2 12c0 1.85.49 3.65 1.41 5.24L2 22l4.76-1.41C8.35 21.51 10.15 22 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2zm4.1 14.31c-.25.73-1.31 1.34-1.97 1.52-.58.16-1.33.29-3.06-.6-2.29-1.18-3.78-4.09-3.89-4.27-.12-.18-.96-1.38-.92-2.61.05-1.22.69-1.8.95-2.07.24-.26.51-.33.68-.33h.47c.16 0 .38.01.56.25.18.25.61.86.67.94.06.08.11.19.01.39-.1.2-.17.31-.32.48-.16.17-.33.38-.47.52-.19.2-.4.42-.17.83.23.41 1.03 1.78 2.24 2.67 1.59 1.15 2.41 1.28 2.83 1.41.41.14.65.12.88-.07.23-.2.98-.92 1.24-1.24.26-.32.52-.28.88-.17.35.11 2.24 1.05 2.62 1.25.39.19.65.28.75.43.1.15.1.86-.15 1.38z"/>
          </svg>
        </a>
      </div>
      
      {/* Call Button */}
      <div className="flex items-center gap-2 group">
        <span className="bg-gray-800 text-white text-xs py-1 px-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
          Call Now
        </span>
        <a
          href={`tel:${phoneNumber}`}
          className="flex items-center justify-center w-10 h-10 bg-blue-500 rounded-full shadow-lg hover:bg-blue-600 hover:scale-110 hover:shadow-xl transition-all duration-200"
        >
          <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
          </svg>
        </a>
      </div>
      
      {/* Address Button with Click to Show/Hide */}
      <div className="relative">
        <div className="flex items-center gap-2 group">
          <span className="bg-gray-800 text-white text-xs py-1 px-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
            School Location
          </span>
          <button
            onClick={toggleAddress}
            className="flex items-center justify-center w-10 h-10 bg-red-500 rounded-full shadow-lg hover:bg-red-600 hover:scale-110 hover:shadow-xl transition-all duration-200"
          >
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </button>
        </div>
        
        {/* Address Card - Toggle on Click */}
        {showAddress && (
          <div className="absolute bottom-full right-0 mb-2 w-72 bg-white rounded-lg shadow-2xl overflow-hidden animate-slideUp">
            <div className="bg-gradient-to-r from-red-600 to-blue-600 p-3">
              <h3 className="text-white font-semibold text-sm">School Address</h3>
            </div>
            <div className="p-3">
              <p className="text-gray-800 text-sm mb-3">{address}</p>
              <button
                onClick={openGoogleMaps}
                className="w-full bg-gradient-to-r from-red-600 to-blue-600 text-white py-2 rounded-lg text-sm font-semibold hover:shadow-lg transition-all"
              >
                Open in Google Maps
              </button>
              <button
                onClick={toggleAddress}
                className="w-full mt-2 text-gray-500 text-xs hover:text-gray-700"
              >
                Close
              </button>
            </div>
            {/* Triangle pointer */}
            <div className="absolute -bottom-2 right-5 w-3 h-3 bg-white rotate-45"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FloatingContactButtons;